import React, { useEffect, useState } from 'react';
import LinkButton, {
  sizes as linkButtonSizes,
  themes as linkButtonThemes,
} from 'components/link-button';
import PropTypes from 'prop-types';
import messageBus from 'js/message-bus';

const ScreenWakeLockButton = ({ label, onButtonText, offButtonText }) => {
  const [isWakeLockActive, setIsWakeLockActive] = useState(false);

  useEffect(() => {
    const token = messageBus.onMessage(
      messageBus.messageTypes.screenWakeLockStateTogglePerformed,
      msg => {
        setIsWakeLockActive(!msg.released);
      }
    );

    return () => {
      messageBus.unsubscribe(token);
    };
  }, []);

  const onScreenWakeLockButtonBtnClick = () => {
    messageBus.sendMessage(
      messageBus.messageTypes.screenWakeLockStateToggleRequested,
      {
        released: isWakeLockActive,
      }
    );
  };

  return (
    <div className="screen-wake-lock-button">
      <span className="screen-wake-lock-button__label">{label}</span>
      <LinkButton
        size={linkButtonSizes.small}
        theme={linkButtonThemes.greenHover}
        text={isWakeLockActive ? onButtonText : offButtonText}
        isActive={isWakeLockActive}
        {...(isWakeLockActive && {
          leftIconName: 'check',
        })}
        className="screen-wake-lock-button__btn"
        onClick={onScreenWakeLockButtonBtnClick}
      />
    </div>
  );
};

ScreenWakeLockButton.propTypes = {
  label: PropTypes.string,
  onButtonText: PropTypes.string,
  offButtonText: PropTypes.string,
};

export default ScreenWakeLockButton;
